// Mock data for Swift AI Indicator clone

export const PURCHASE_URL = "https://onetapay.com/pp/MTQ3OQ==";
export const SUPPORT_EMAIL = "support@swifttechnicals.com";
export const TELEGRAM_URL = "https://telegram.me/+ljYXMuzthaZjMDRl";
export const TELEGRAM_SUPPORT = "https://t.me/IndicatorSetup";

export const liveSignals = [
  {
    id: 1,
    image:
      "https://swifttechnicals.com/wp/wp-content/uploads/2024/12/Untitled_design_-_2024-12-10T195107.957-removebg-preview-1.png",
    points: "+200 pts",
  },
  {
    id: 2,
    image:
      "https://swifttechnicals.com/wp/wp-content/uploads/2024/12/Untitled_design_-_2024-12-10T195046.212-removebg-preview-1.png",
    points: "+350 pts",
    highlighted: true,
  },
  {
    id: 3,
    image:
      "https://swifttechnicals.com/wp/wp-content/uploads/2024/12/Untitled_design_-_2024-12-10T195016.138-removebg-preview-1.png",
    points: "+300 pts",
  },
];

export const steps = [
  {
    number: 1,
    title: "Purchase The Swift-AI Indicator",
    sub: "One-Time Payment · Lifetime Validity + Free Updates",
    description:
      "Tap the Buy Now button to complete your one-time purchase. Get instant access to the Swift-AI TradingView indicator with lifetime validity and all future updates included.",
  },
  {
    number: 2,
    title: "Send Your TradingView ID For Activation",
    sub: "Email your TradingView username to support@swifttechnicals.com",
    description:
      "After purchase, share your TradingView ID with our team. We activate the indicator on your account within a few hours and share the 3 complimentary Chartink scanners.",
  },
  {
    number: 3,
    title: "Follow Signals & Hit Big Targets",
    sub: "Limited high-quality signals · Big targets (not scalp)",
    description:
      "Swift-AI focuses on limited but high-probability setups with large target moves. Combine the indicator alerts with our free Chartink scanners to spot the strongest stocks daily.",
  },
];

export const reviews = [
  {
    id: 1,
    image:
      "https://swifttechnicals.com/wp/wp-content/uploads/2024/12/WhatsApp-Image-2024-12-23-at-13.29.41.jpeg",
    name: "Verified Trader",
    purchase: "Verified Purchase",
  },
  {
    id: 2,
    image:
      "https://swifttechnicals.com/wp/wp-content/uploads/2024/12/WhatsApp-Image-2024-12-23-at-13.29.41-1.jpeg",
    name: "Verified Trader",
    purchase: "Verified Purchase",
  },
];

export const featurePills = [
  { label: "TradingView Indicator", color: "#38bdf8" },
  { label: "Big Target Signals", color: "#facc15" },
  { label: "3 Free Chartink Scanners", color: "#22c55e" },
  { label: "Lifetime Validity + Updates", color: "#a78bfa" },
];

export const bonuses = [
  {
    title: "Momentum Breakout Scanner",
    desc: "Instantly filter stocks breaking out of consolidation with high volume — your daily hunting ground.",
    worth: "₹5,000",
  },
  {
    title: "BTST Scanner",
    desc: "Identify high-momentum stocks at end of day that are likely to gap up next morning — perfect for Buy Today, Sell Tomorrow setups.",
    worth: "₹5,000",
  },
  {
    title: "Intraday Power Scanner",
    desc: "Discover the strongest intraday candidates with our proprietary Chartink logic — updated live.",
    worth: "₹5,000",
  },
];
